export default __webpack_public_path__ + "static/media/kJEhBvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oFsI.8a1c11c8.woff2";